import { Talent } from "../../Classes";

const tier6 = [
  null,
  new Talent(
    "Shadow Mastery",
    "spell_shadow_shadetruesight",
    [
      "Increases the damage dealt and life drained by your Shadow spells by ",
      "%.",
    ],
    5,
    [[2, 4, 6, 8, 10]],
    [{ x: 4, y: 1 }]
  ),

  null,
  null,
];

export default tier6;
